// extracted by mini-css-extract-plugin
module.exports = {"errorStyle":"EmployeeViewTableChildRows_errorStyle__21tex","missingInfo":"EmployeeViewTableChildRows_missingInfo__Op-nI"};